import { IObject } from "@/objects/Index";
import CryptoJS from 'crypto-js'

/**
 * 随机颜色
 * @returns 
 */
function getRandomColor() {
  let letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

/**
 * 获取对象下的字段值
 * @param record {}
 * @param key 'a.b.c'
 * @param defaultValue
 * @returns
 */
function getValueByKeys (record: IObject = {}, key: string, defaultValue?: unknown): any {
  const keys = key.split(".");
  for (let i = 0; i < keys.length; i++) {
    record = record[keys[i]] || (i === keys.length - 1 ? defaultValue : {});
  }
  return record || defaultValue;
};

/**
 * 加密函数
 * @param data 数据
 * @param passphrase 密钥
 * @returns 
 */
function encrypt(data, passphrase): string {
  let ciphertext = CryptoJS.AES.encrypt(data, passphrase);
  return ciphertext.toString();
}

/**
 * 解密函数
 * @param ciphertext 加密串
 * @param passphrase 秘钥
 * @returns 
 */
function decrypt(ciphertext, passphrase): string {
  let bytes = CryptoJS.AES.decrypt(ciphertext, passphrase);
  let originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
}

function isEmptyString(str: any): boolean {
  return typeof str === 'string' && (!str || str === '');
}

function stringify(obj) {
  return JSON.stringify(obj, (key, val) => {
    if (typeof val === 'function') {
      return `${val}`
    }
    return val
  })
}

function parse(str) {
  return JSON.parse(str, (k, v) => {
    if (v!==null&&v.indexOf && v.indexOf('function') > -1) {
      return eval(`(${v})`)
    }
    return v
  })
}

function jsonClone(obj) {
  return parse(stringify(obj));
}

function makeMap(str, expectsLowerCase?) {
  const map = Object.create(null)
  const list = str.split(',')
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true
  }
  return expectsLowerCase
    ? val => map[val.toLowerCase()]
    : val => map[val]
}

function toPrefixUpperCase(format) {
  let formatStr = format.split(' ')
  if (formatStr.length > 1) {
    return `${formatStr[0].toUpperCase()} ${formatStr[1]}` 
  }
  return format.toUpperCase()
}

export const isAttr = makeMap(
  'accept,accept-charset,accesskey,action,align,alt,async,autocomplete,'
  + 'autofocus,autoplay,autosave,bgcolor,border,buffered,challenge,charset,'
  + 'checked,cite,class,code,codebase,color,cols,colspan,content,http-equiv,'
  + 'name,contenteditable,contextmenu,controls,coords,data,datetime,default,'
  + 'defer,dir,dirname,disabled,download,draggable,dropzone,enctype,method,for,'
  + 'form,formaction,headers,height,hidden,high,href,hreflang,http-equiv,'
  + 'icon,id,ismap,itemprop,keytype,kind,label,lang,language,list,loop,low,'
  + 'manifest,max,maxlength,media,method,GET,POST,min,multiple,email,file,'
  + 'muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,'
  + 'preload,radiogroup,readonly,rel,required,reversed,rows,rowspan,sandbox,'
  + 'scope,scoped,seamless,selected,shape,size,type,text,password,sizes,span,'
  + 'spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,'
  + 'target,title,type,usemap,value,width,wrap'
)

export {
  getRandomColor,
  getValueByKeys,
  encrypt,
  decrypt,
  isEmptyString,
  makeMap,
  stringify,
  parse,
  jsonClone,
  toPrefixUpperCase
}